import { render, staticRenderFns } from "./ActivityMessage.vue?vue&type=template&id=1dc88243&"
import script from "./ActivityMessage.vue?vue&type=script&lang=js&"
export * from "./ActivityMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports